import { z } from 'zod';

import { BorrowerId, PayeeId, PaymentId } from '../BrandedIds';
import { zodDateOrString } from '../utils/Zod';
import { BaseLoanEvent } from './BaseLoanEvent';

export const CreateForwardPaymentDisbursementEvent = BaseLoanEvent.extend({
  type: z.literal('createForwardPaymentDisbursement'),
  paymentId: PaymentId,
  date: zodDateOrString,
  recipient: z.string(),
  payeeId: PayeeId.optional(),
  borrowerId: BorrowerId.optional(),
  comment: z.string().optional(),
});
export type CreateForwardPaymentDisbursementEvent = z.infer<typeof CreateForwardPaymentDisbursementEvent>;
